const toSizeLabel = (size = 0) => {
  if (!size || Number.isNaN(Number(size))) return '';
  const kb = Math.max(1, Math.round(Number(size) / 1024));
  return `${kb} KB`;
};

const readFileAsDataUrl = (file) =>
  new Promise((resolve) => {
    if (!file) {
      resolve(null);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      resolve({
        name: file.name || 'Attachment',
        type: file.type || 'file',
        size: toSizeLabel(file.size),
        fileUrl: reader.result?.toString() || '',
        uploadedAt: new Date().toISOString()
      });
    };
    reader.onerror = () => {
      resolve({
        name: file.name || 'Attachment',
        type: file.type || 'file',
        size: toSizeLabel(file.size),
        fileUrl: '',
        uploadedAt: new Date().toISOString()
      });
    };
    reader.readAsDataURL(file);
  });

export const readFilesAsStoredAttachments = async (fileList, uploadedBy = 'System') => {
  const files = Array.from(fileList || []);
  if (files.length === 0) return [];
  const attachments = await Promise.all(files.map((file) => readFileAsDataUrl(file)));
  return attachments
    .filter(Boolean)
    .map((attachment) => ({
      ...attachment,
      uploadedBy
    }));
};

